'use strict';

function normalizeCandidate(candidate, index) {
  return {
    rank: Number(candidate?.rank) || index + 1,
    category_id: String(candidate?.category_id || '').trim(),
    category_name: candidate?.category_name || null,
    domain_id: candidate?.domain_id || null,
    domain_name: candidate?.domain_name || null
  };
}

async function evaluateCandidates(candidates, getCategoryDetail) {
  const evaluations = [];

  for (const [index, rawCandidate] of (Array.isArray(candidates) ? candidates : []).slice(0, 3).entries()) {
    const candidate = normalizeCandidate(rawCandidate, index);
    if (!candidate.category_id) {
      evaluations.push({ ...candidate, usable: false, reason: 'missing_category_id' });
      continue;
    }

    let detail = null;
    try {
      detail = await getCategoryDetail(candidate.category_id);
    } catch {
      detail = null;
    }

    if (!detail) {
      evaluations.push({ ...candidate, usable: false, reason: 'not_found' });
      continue;
    }

    const children = Array.isArray(detail.children_categories) ? detail.children_categories : [];
    if (children.length > 0) {
      evaluations.push({ ...candidate, usable: false, reason: 'not_leaf' });
      continue;
    }

    if (detail?.settings?.listing_allowed === false) {
      evaluations.push({ ...candidate, usable: false, reason: 'listing_not_allowed' });
      continue;
    }

    evaluations.push({ ...candidate, usable: true });
    return { selected: evaluations[evaluations.length - 1], evaluations };
  }

  return { selected: null, evaluations };
}

async function resolvePreflightCategory({ candidates, requestedCategoryId, getCategoryDetail }) {
  const predictionResult = await evaluateCandidates(candidates, getCategoryDetail);
  if (predictionResult.selected) {
    return {
      effectiveCategoryId: predictionResult.selected.category_id,
      source: `domain_discovery_rank_${predictionResult.selected.rank}`,
      predictions: predictionResult.evaluations,
      base: null
    };
  }

  const baseResult = await evaluateCandidates(
    requestedCategoryId ? [{ rank: 1, category_id: requestedCategoryId }] : [],
    getCategoryDetail
  );

  return {
    effectiveCategoryId: baseResult.selected?.category_id || null,
    source: baseResult.selected ? 'base_fallback' : 'unresolved',
    predictions: predictionResult.evaluations,
    base: baseResult.evaluations[0] || null
  };
}

function markPreflightCategory(product, categoryId) {
  const correctedProduct = { ...(product || {}), category_id: categoryId };
  Object.defineProperty(correctedProduct, '__categoryPreflightResolved', {
    value: true,
    enumerable: false
  });
  return correctedProduct;
}

function isPreflightCategoryResolved(product) {
  return product?.__categoryPreflightResolved === true;
}

module.exports = {
  evaluateCandidates,
  resolvePreflightCategory,
  markPreflightCategory,
  isPreflightCategoryResolved
};
